let contentPurposeTypes = [
  { label: "Volunteers Needed", value: "VOLUNTEERS_NEEDED" },
  { label: "Funds Needed", value: "FUNDS_NEEDED" },
  { label: "Collaboration Req", value: "COLLABORATION_REQ" },
  { label: "Good News", value: "GOOD_NEWS" },
  { label: "Raise Issue", value: "RAISE_ISSUE" },
  { label: "Certificate", value: "GOT_CERTIFICATE" },
];

//GOT_CERTIFICATE

export default contentPurposeTypes;
